import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import { Link } from 'gatsby'

import { getLabel } from '@/utils/products'
import Image from '@/components/Image'
import { MAX_SEARCH_RESULTS_COUNT } from '@/constants'

import MoreResultsButton from './MoreResultsButton'
import styles from './styles'

const fallbackThumbnailCss = ({ colors }) => css`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: contain;
  border: 1px solid ${colors.iron};
  background-color: ${colors.white};
`

const Results = ({
  items,
  query,
  resultsRef,
  activeItemIndex,
  onActiveItemIndexChange,
}) => {
  if (!items?.length || window?.location?.pathname === '/search/') {
    return null
  }

  const isMoreResultsActive = activeItemIndex === MAX_SEARCH_RESULTS_COUNT
  const shouldDisplayMoreResultBtn =
    items && items.length > MAX_SEARCH_RESULTS_COUNT

  return (
    <div
      className="autocomplete-results"
      css={styles.results(shouldDisplayMoreResultBtn)}
    >
      <ul className="autocomplete-list" ref={resultsRef}>
        {items?.map((item, index) => {
          const categoryName = item.category ? getLabel(item.category.name) : ''

          const isActive =
            activeItemIndex !== null &&
            items[activeItemIndex] &&
            item.id === items[activeItemIndex].id

          if (index >= MAX_SEARCH_RESULTS_COUNT) {
            return null
          }

          return (
            <li
              className="autocomplete-item"
              onMouseEnter={() => onActiveItemIndexChange(index)}
              key={item.objectID}
              css={(theme) => css`
                background-color: ${isActive ? theme.colors.grey : 'initial'};
              `}
            >
              <Link
                className="autocomplete-item__link"
                to={'/apps/' + item.slug + '/'}
              >
                {item.icons?.small ? (
                  <img src={item.icons.small} alt={item.name} />
                ) : (
                  <Image
                    css={fallbackThumbnailCss}
                    type="fallbackThumbnail"
                    loading="eager"
                    alt="Application thumbnail"
                  />
                )}

                <div className="autocomplete-item__info">
                  <span className="autocomplete-item__name">{item.name}</span>

                  {categoryName && (
                    <span className="autocomplete-item__category">
                      {categoryName}
                    </span>
                  )}
                </div>
              </Link>
            </li>
          )
        })}

        {shouldDisplayMoreResultBtn && (
          <MoreResultsButton
            items={items}
            query={query}
            onActiveItemIndexChange={onActiveItemIndexChange}
            isMoreResultsActive={isMoreResultsActive}
          />
        )}
      </ul>
    </div>
  )
}

Results.propTypes = {
  items: PropTypes.array,
  query: PropTypes.string,
  activeItemIndex: PropTypes.number,
  onActiveItemIndexChange: PropTypes.func,
  resultsRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
}

export default Results
